import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ClientService } from './client.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WarehouseService {

  public WareHouseOrders$ = new BehaviorSubject<Order[]>(new Array<Order>());
  itemStocks$ = new BehaviorSubject<itemStock[]>(new Array<itemStock>());
  itemStockDetails$ = new BehaviorSubject<itemStockDetails[]>(new Array<itemStockDetails>());
  ItemsAvailable$ = new BehaviorSubject<itemStockDetails[]>(new Array<itemStockDetails>());


  constructor(private httpClient: HttpClient, private client: ClientService) { }

  GetItemStocks() {
    return this.httpClient.get<itemStock[]>(`${environment.apiUrl}/warehouse/itemstocks/getforclient?clientId=${this.client.clientId}`);
  }

  GetItemStocksCSV() {
    return this.httpClient.get(`${environment.apiUrl}/warehouse/itemstocks/getforclientcsv?clientId=${this.client.clientId}`);
  }

  GetWareHouseOrders(searchParms:{fromDate:Date,toDate:Date} = {fromDate:null,toDate:null}) {
    let clientObject = {
      ClientId: this.client.clientId,
      Statuses: Object.values(Statuses),
      Directions: Object.values(Direction),
      FromDate:searchParms.fromDate,
      ToDate:searchParms.toDate
    } as IGetOrderPost


    this.httpClient.post<Order[]>(`${environment.apiUrl}/warehouse/orders/get`, clientObject).subscribe(x => {
      this.WareHouseOrders$.next(x)
    });
  }
  /**
   * 
   * @param itemId a guid in a string
   * @returns a subscription.
   */
  GetItemStockDetails(itemIdGuid: string, inStock: boolean) {
    let postobject = { itemId: itemIdGuid, clientId: this.client.clientId, instock: inStock };
    this.httpClient.post<itemStockDetails[]>(`${environment.apiUrl}/warehouse/itemstocks/get`, postobject).subscribe(x => {
      this.itemStockDetails$.next(x);
    });
  }
  CreateOrder(value: CreateOrdreRequest) {
    if (value.clientId == null)
      value.clientId = this.client.clientId;
    if (value) {
      this.httpClient.post<response>(`${environment.apiUrl}/warehouse/orders/create`, value).subscribe(x => { this.GetWareHouseOrders(); });
    }
    else
      throw new Error("value was null when trying to create new order line 53");

  }
  GetItemsForOrderDropDown() {
    this.httpClient.post<GetItems[]>(`${environment.apiUrl}/warehouse/items/get`, { clientId: this.client.clientId }).subscribe(x => {
      let temp = new Array<itemStockDetails>();
      temp = x.map(item => {
        return {
          bpl: item.bpl,
          amountOnPallet: item.maxAmountOnPallet,
          barcode: "",
          clientId: item.clientId,
          colliType: item.colliType,
          description: item.description,
          itemCode:item.itemCode,
          ean:item.ean,
          id:item.id,
          itemId:item.id,
          itemName:item.name,
          locationType:item.locationType,
          name:item.name,
          width:item.width,
          length:item.length,
          stackable:item.stackable ? 1 : 0,
          itemDescription:item.description,
        } as itemStockDetails
      });

      this.ItemsAvailable$.next(temp);
    });
  }
}

// descipes a simple itemstock
export interface itemStock {

  colliType: string
  id: string
  itemCode: string
  itemDescription: string
  itemName: string
  maxAmountOnPallet: number;
  totalAmount: number;
  totalPalletsAmount: number;
  isDeleted:boolean;
}
// itemStockWithArray is used to expand "large oversigt" with a expandable thing.
export interface itemStockWithArray extends itemStock {
  details: itemStockDetails[]
}

// is used internal (in warehouse) to get orders
interface IGetOrderPost {
  OrderId: string;
  ClientId: string;
  Statuses: string[];
  FromDate: Date;
  ToDate: Date;
  Directions: string[];
  IncludeStockItems: boolean;
}
// is used internal to handle mapping to a order.
interface Order {

  clientId: string;
  clientName: string;
  clientNumber: number | string | any;
  direction: string;
  id: string;
  orderDate: Date;
  orderLines: OrderLines[]
  orderNumber: string;
  orderServices: OrderServices[]
  refference: string;
  status: string;

  OrderNo: number;
  DeliveryDate: Date;
  DeliveryOrderNo: string;
  DeliveryNote: string;
  DeliveryName: string;
  DeliveryStreet: string;
  DeliveryZipCode: string;
  DeliveryCity: string;
  DeliveryCountryCode: string;
  DeliveryContactPerson: string;
  DeliveryContactEmail: string;
  DeliveryContactPhone: string;

}
// is used to displey orderlines under "Order oversigt".
export interface OrderLines {
  amount: number;
  amountOnPallet: number;
  barcode: string;
  batchNo: string;
  id: string;
  itemCode: null
  itemId: string;
  itemName: null
  note: string;
  orderId: string;
  picks: any[]
}
// a sub object to order
export interface OrderServices {
  amount: number;
  id: string;
  note: string;
  orderId: string;
  serviceName: string;
  serviceType: string;
}
// this object descripes how details looks under a item
// Note: this object have added "changeAmountOnPallet" prop for only to be used in the frontend
export interface itemStockDetails {
  bpl: 1
  clientId: string;
  colliType: string;
  description: string;
  ean: string;
  id: string;
  itemCode: string;
  length: number;
  locationType: number;
  amountOnPallet: number;
  name: string;
  priceType: number;
  stackable: number;
  width: number;
  selected: boolean;
  batchNo: string | number;
  date: Date;
  changeAmountOnPallet: number;
  barcode: string;
  dtm: Date;
  externalBarcode: string;
  itemDescription: string;
  itemId: string;
  itemName: string;
  location: string;
  orderNoIn: string;
  orderNoOut: string;
}
// a object used to send a post to create a order.
export interface CreateOrdreRequest {
  id: string;
  clientId: string;
  status: string;
  direction: string;
  refference: string;
  orderDate: Date;
  orderLines: IOrderLinesCreateOrder[];
  orderServices: OrderServices[];
  deliveryDate: Date
  deliveryOrderNo: string;
  deliveryNote: string;
  deliveryName: string;
  deliveryStreet: string;
  deliveryZipCode: string;
  deliveryCity: string;
  deliveryCountryCode: string;
  deliveryContactPerson: string;
  deliveryContactEmail: string;
  deliveryContactPhone: string;
}
// a simple object to hold response infomation from api
interface response {
  id: string;
  error: string;
}
// a simple object to descripe how the request for createorder lines looks like
export interface IOrderLinesCreateOrder {
  ItemId: string;
  ItemStockId: string;
  Amount: string;
  AmountOnPallet: string;
  Note: string;
  Barcode: string;
  BatchNo: string;
}

export interface GetItems {
  id: string; // Guid -> string
  name: string;
  description: string;
  ean: string;
  stackable: boolean;
  locationType: number;
  priceType: number;
  itemCode: string;
  colliType: string;
  maxAmountOnPallet: number;
  length: number; // float -> number
  width: number;  // float -> number
  bpl: number;    // float -> number
  clientId: string; // Guid -> string
  fstValue: FstItemResponse;
  canBeDeleted: boolean;
  itemCount: number;
}

export interface FstItemResponse {
  nonEcologlig: boolean;
  specfication: string;
  unitOfMessurment: string;
}

// descipes the statuses that are in the system
// Note: this also binds to how the translation works
export enum Statuses {
  new = "07d27fec-bf35-48d6-8fd8-2f5b81bdfd55",
  Accepted = "c3734936-05fc-45ed-b8bc-68a689a5068e",
  Picked = "4edad8fe-df43-428c-8f15-43d1d118a287",
  Prosessed = "ecbed7aa-d57d-4fb3-a3df-a3dc0bf81e9d",
  Deleted = "f83a3b52-7031-4c0b-85b9-dca2303260a5"
}
// descipes the direction that are in the system
// Note: this also binds to how the translation works
export enum Direction {
  In = "e681a2fd-b73b-404d-8db0-fd93b42ce41c",
  Out = "8d8041a7-bc5d-49fc-afdc-f12db4ce6b28"
}